<template>
  <!-- 地圖視窗 -->
  <ui-modal ref="branchMapModal" :header-title="headerTitle" :forcing="true" :hide-overlay="false" :modal-width="720">
    <div class="map-container px-5 pb-6">
      <iframe width="100%" height="404" frameborder="0" style="border: 0" :src="googleMapEmbedSrc" allowfullscreen />
    </div>
  </ui-modal>
</template>

<script setup lang="ts">
import UiModal from '@/components/dialog/ui-modal.vue'

defineOptions({
  name: 'BranchMapModal',
})

const props = defineProps<{
  branch: { lat: number; lng: number; area: string; address: string }
  title?: string
}>()

const { t } = useI18n()
const branchMapModal = useTemplateRef('branchMapModal')

const { branch } = toRefs(props)

const { googleMapEmbedSrc } = useAddress(branch)

const headerTitle = computed(() => (props.title !== '' ? props.title : t('check_map')))

defineExpose({
  showModal,
  hideModal,
})

function showModal() {
  branchMapModal.value?.showModal()
}

function hideModal() {
  branchMapModal.value?.hideModal()
}
</script>

<style lang="scss" scoped>
.map-container {
  width: 100%;
}
</style>
